import { render, staticRenderFns } from "./foundation.vue?vue&type=template&id=ec439370&scoped=true"
import script from "./foundation.vue?vue&type=script&lang=js"
export * from "./foundation.vue?vue&type=script&lang=js"
import style0 from "./foundation.vue?vue&type=style&index=0&id=ec439370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec439370",
  null
  
)

export default component.exports